import { Service } from "@warda/library-ui/contexts/AppWebSocketContext";
import { BASE_URL, PRODUCT_ID } from "../constants/keys";
const apiUrls = {
    fileTypesSynoptic: {
        url: () => `/${Service.SC}/fileTypes/synoptic`,
        method: "GET",
    },
    getUsers: {
        url: () => `${BASE_URL}/${Service.USERS}/user?app=${PRODUCT_ID}`,
        method: "GET",
    },
    getUserProfile: {
        url: () => `${BASE_URL}/${Service.USERS}/user/profile?app=${PRODUCT_ID}`,
        method: "GET",
    },
    profilePictureUpload: {
        url: () => `${BASE_URL}/${Service.USERS}/user/profile/picture/upload`,
        method: "POST",
    },
    profilePictureConfirm: {
        url: (fileId) => `${BASE_URL}/${Service.USERS}/user/profile/picture/confirm/${fileId}`,
        method: "PUT",
    },
    putUserProfile: {
        url: () => `${BASE_URL}/${Service.USERS}/user/profile`,
        method: "PUT",
    },
};
export default apiUrls;
